import React from 'react'
import { ChakraProvider, createSystem, defaultConfig } from '@chakra-ui/react'
import { ColorModeProvider, type ColorModeProviderProps } from './ColorModeProvider'

interface UIProviderProps {
  children: React.ReactNode
  system?: ReturnType<typeof createSystem>
  colorModeProviderProps?: ColorModeProviderProps
}

export const UIProvider: React.FC<UIProviderProps> = ({ children, system, colorModeProviderProps }) => {
  const themeSystem = system ?? createSystem(defaultConfig)
  
  return (
    <ChakraProvider value={themeSystem}>
      <ColorModeProvider {...colorModeProviderProps}>
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  )
} 